<form
  id="switchForm"
  #switchForm
  id="form1"
  action="https://webpay.interswitchng.com/paydirect/pay"
  method="post"
></form>
<div class="container-fluid" id="c-f">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="card custom-card">
        <div class="card-body">
          <div class="flex flex-wrap items-center justify-between gap-3 mb-2">
            <span>
              TUITION PAYMENT <small class="text-danger">(invoices)</small>
            </span>
            <button mat-raised-button (click)="transferPayment()">
              Transfer Payment
            </button>
          </div>
          <div class="p-3 shadow" *ngIf="paymentHistory.length == 0">
            You currently do not have any invoice
          </div>
          <mat-accordion class="col-12" *ngIf="paymentHistory.length > 0">
            <mat-expansion-panel
              (click)="invoiceClicked(pay, i)"
              [disabled]="disabledInvoice(pay, i)"
              *ngFor="let i = index; let pay; of: paymentHistory"
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span class="text-sm line-clamp-2 md:text-base"
                    >{{ pay.category | uppercase }} -
                    {{ pay.name | uppercase }} - {{ pay.tag | uppercase }} -
                    {{ pay.term | uppercase }}</span
                  >
                  <span
                    *ngIf="pay.amount_remaining <= 0 && pay.total_amount > 0"
                    class="ml-3 badge badge-success"
                    >PAID</span
                  >
                </mat-panel-title>
              </mat-expansion-panel-header>

              <table class="table">
                <tr>
                  <th>Fee</th>
                  <th>Amount</th>
                </tr>
                <tr *ngFor="let fee of pay.invoice_details">
                  <td>{{ fee.title }}</td>
                  <td>{{ fee.amount.toLocaleString() }}</td>
                </tr>
                <tr>
                  <td>Total:</td>
                  <td class="font-semibold">
                    {{ pay.total_amount.toLocaleString() }}
                  </td>
                </tr>
                <tr>
                  <td>Amount Paid:</td>
                  <td class="font-medium">
                    {{ pay.total_paid.toLocaleString() }}
                  </td>
                </tr>
                <!-- <tr>
                  <td>Transaction charge</td>
                  <td>+ {{pay.charge}}</td>
                </tr> -->
                <br />
                <!-- <tr>
                    <td><strong>Net Total:</strong> </td>
                    <td><strong>{{pay.amount_remaining + pay.charge}}</strong></td>
                </tr> -->
              </table>
              <div class="flex flex-wrap gap-y-2 gap-x-4">
                <!-- <div *ngIf="pay.amount_remaining > 0" class="row"> -->

                <div
                  class="w-full mb-1 text-xs"
                  *ngIf="this.partPayment?.control && pay.amount_remaining > 0"
                >
                  You can't pay less than
                  {{ pay.minimum | currency : "NGN" : "symbol-narrow" }} online.
                </div>
                <div>
                  <!-- <mat-form-field appearance="fill">
										<mat-label>Payment Option</mat-label>
										<mat-select name="lecture" [(ngModel)]="payOption"
											(ngModelChange)="changePayOption()">
											<mat-option value="full">Full Payment</mat-option>
											<mat-option value="part" [disabled]="!partPayment.control">Part
												Payment</mat-option>
										</mat-select>
									</mat-form-field> -->
                  <input
                    type="number"
                    [(ngModel)]="pay.custom_amount"
                    (ngModelChange)="updatePays()"
                    (blur)="updatePays(true)"
                    *ngIf="
                      this.partPayment?.control && pay.amount_remaining > 0
                    "
                    class="border-[1px] outline-none w-40 font-medium px-2 focus:border-gr400 rounded-md overflow-hidden transition-all duration-300 flex items-center gap-2 h-11 invalid:border-red-700 invalid:text-red-700 invalid:focus:border-red-700"
                    [min]="
                      this.partPayment.control
                        ? pay.minimum
                        : pay.amount_remaining
                    "
                    required
                  />
                </div>

                <!-- INTERSWITCH -->
                <div
                  *ngIf="
                    hasOnline &&
                    hasSwitch &&
                    pay.amount_remaining > 0 &&
                    pay.custom_amount >= pay.minimum
                  "
                >
                  <ng-interswitch
                    [paymentOptions]="pay.paymentOptions"
                    (paymentCallback)="handlePaymentInterswitch($event, pay)"
                    [class]="'btn btn-danger'"
                  >
                    Pay with Interswitch
                  </ng-interswitch>
                  <br />
                  <small
                    >Charge:
                    {{ "300" | currency : "NGN" : "symbol-narrow" }}</small
                  >
                  <br />
                  <span class="ml-2">
                    Total:
                    <b>{{
                      pay.custom_amount + 300
                        | currency : "NGN" : "symbol-narrow"
                    }}</b>
                  </span>
                </div>

                <!-- PAYSTACK -->
                <div
                  *ngIf="hasOnline && hasPaystack && pay.amount_remaining > 0"
                >
                  <button
                    [disabled]="pay.custom_amount < pay.minimum"
                    mat-raised-button
                    class="btn btn-primary"
                    (click)="handlePaymentPaystack(pay)"
                  >
                    Pay with Paystack
                  </button>
                  <br />
                  <small>
                    Charge:
                    {{
                      pay.paystack_charge | currency : "NGN" : "symbol-narrow"
                    }}
                  </small>
                  <br />
                  <span class="ml-2">
                    Total:
                    <b>{{
                      pay.custom_amount + pay.paystack_charge
                        | currency : "NGN" : "symbol-narrow"
                    }}</b>
                  </span>
                </div>

                <!-- WALLET -->
                <div *ngIf="hasOnline && hasWallet">
                  <button
                    mat-raised-button
                    class="btn btn-danger"
                    [disabled]="pay.custom_amount < pay.minimum"
                    (click)="handlePaymentWallet(pay)"
                  >
                    Pay into Wallet
                  </button>
                  <br />
                  <small
                    >Charge:
                    {{ "150" | currency : "NGN" : "symbol-narrow" }}</small
                  >
                  <br />
                  <span class="ml-2">
                    Total:
                    <b>{{
                      pay.custom_amount + 150
                        | currency : "NGN" : "symbol-narrow"
                    }}</b>
                  </span>
                </div>

                <!-- SLIP UPLOAD -->
                <div
                  *ngIf="
                    (hasSlipUpload && !hasOnline) ||
                    (hasOnline && hasSlipUpload)
                  "
                >
                  <button
                    mat-raised-button
                    class="btn btn-secondary"
                    (click)="handlePaymentUpload(pay)"
                  >
                    Pay by Slip Upload
                  </button>
                </div>

                <!-- {{pay.paymentOptions | json}} -->
                <!-- <div class="text-center">
			   <img *ngIf="paymentGateway == 'interswitch'" src="assets/images/interswitch-logo.png" alt="interswitch logo" id="interswitch-logo" />
			 </div> -->
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</div>
